import { AdminSession, SessionStatus } from '@airreading/common/data';
import { ReactNode } from 'react';
import { SessionStatusChangeModal } from './session-status-change-modal.js';

interface CancelSessionsProps {
  sessions: AdminSession[];
  trigger: ReactNode;
  onSuccess?: () => void;
}

export const CancelSessions = ({ sessions, trigger, onSuccess }: CancelSessionsProps) => {
  return (
    <SessionStatusChangeModal
      sessions={sessions}
      trigger={trigger}
      targetStatus={SessionStatus.cancelled}
      modalTitle="Are you sure you want to cancel the following sessions?"
      noValidSessionsTitle="Sessions canceled"
      confirmBtnLabel="Cancel sessions"
      description="All student attendance will be canceled and an email will be sent to the teacher notifying the session was canceled."
      noValidSessionsMessage="These sessions have already been canceled and cannot be canceled again."
      invalidSessionsMessage="There {are} {count} {session} that cannot be canceled. Scheduled, in-progress, and completed sessions can be canceled; already canceled sessions are excluded."
      buttonVariant="destructive"
      onSuccess={onSuccess}
    />
  );
};
